
if (!customElements.get('quantity-gifts')) {
  class QuantityGifts extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.gifts = Array.from(this.querySelectorAll('.quantity-gift'));
      this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`) || this.closest('product-info')?.querySelector('input[name="quantity"]');
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
    }

    connectedCallback() {
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', this.handleQuantityChange);
        this.quantityInput.addEventListener('input', this.handleQuantityChange);
      }
      this.handleQuantityChange();
    }

    disconnectedCallback() {
      if (this.quantityInput) {
        this.quantityInput.removeEventListener('change', this.handleQuantityChange);
        this.quantityInput.removeEventListener('input', this.handleQuantityChange);
      }
    }

    getSelectedQuantity() {
      const value = parseInt(this.quantityInput?.value || '1', 10);
      return Number.isNaN(value) ? 1 : value;
    }

    handleQuantityChange() {
      this.unlockGifts(this.getSelectedQuantity());
    }

    unlockGifts(quantity) {
      this.unlockedItems = [];
      this.gifts.forEach((gift) => {
        const requiredQty = parseInt(gift.dataset.quantity || '0', 10);
        const isUnlocked = quantity >= requiredQty;
        gift.classList.toggle('quantity-gift--unlocked', isUnlocked);
        gift.dataset.unlocked = isUnlocked ? 'true' : 'false';
        if (isUnlocked && gift.dataset.product) {
          this.unlockedItems.push({
            id: gift.dataset.product,
            threshold: requiredQty,
            handle: gift.dataset.handle || '',
          });
        }
      });
    }

    getUnlockedGiftItems() {
      return Array.isArray(this.unlockedItems) ? this.unlockedItems : [];
    }

    getAllGiftItems() {
      return this.gifts.map((gift) => ({
        id: gift.dataset.product,
        threshold: parseInt(gift.dataset.quantity || '0', 10),
        handle: gift.dataset.handle || '',
      })).filter((gift) => gift.id);
    }
  }

  customElements.define('quantity-gifts', QuantityGifts);
}
